import { render, staticRenderFns } from "./r-currency-table-dialog.vue?vue&type=template&id=59d8dde5&scoped=true"
import script from "./r-currency-table-dialog.vue?vue&type=script&lang=js"
export * from "./r-currency-table-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-currency-table-dialog.vue?vue&type=style&index=0&id=59d8dde5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d8dde5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59d8dde5')) {
      api.createRecord('59d8dde5', component.options)
    } else {
      api.reload('59d8dde5', component.options)
    }
    module.hot.accept("./r-currency-table-dialog.vue?vue&type=template&id=59d8dde5&scoped=true", function () {
      api.rerender('59d8dde5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-currency-table-dialog.vue"
export default component.exports